import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatNull } from '../../Utils/GlobalUtils';

import Loading from '../Loading';
import WarningPanel from '../WarningPanel';

import miniTable from '../../styles/MiniTables.module.css';

import IconContainer from '../IconContainer';
import { ReactComponent as CheckIcon } from '../../icons/check.svg';
import { ReactComponent as PlusIcon } from '../../icons/plus.svg';

export default function InputDebtorSelector({
    initialSearchTerm,
    formInfo,
    setFormInfo,
    errorsForm,
    setErrorsForm,
    isAddNew,
    entity_type = 'Все',
}) {
    const { openTimeModal } = useTimeModal();

    const [cases, setCases] = React.useState([]);
    const [isAllowSearching, setIsAllowSearching] = React.useState(true);
    const [searchTerm, setSearchTerm] = React.useState('');
    const [debouncedSearchTerm, setdebouncedSearchTerm] = React.useState('');

    const [loading, setLoading] = React.useState(true);

    const wrapperRef = React.useRef();

    const [activeIndex, setActiveIndex] = React.useState(-1);

    React.useEffect(() => {
        if (initialSearchTerm) {
            setSearchTerm(initialSearchTerm);
            setIsAllowSearching(false);
        }
    }, [initialSearchTerm]);
  
    React.useEffect(() => {
        const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsAllowSearching(false);
        }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Дебаунс ввода
    React.useEffect(() => {
        const handler = setTimeout(() => {
        setdebouncedSearchTerm(searchTerm);
        }, 500);

        return () => clearTimeout(handler);
    }, [searchTerm]);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        setLoading(true);
        setActiveIndex(-1);

        if (isAllowSearching && debouncedSearchTerm.trim() !== '') {
            axios.get(`/api/search-debtors?searchterm=${encodeURIComponent(debouncedSearchTerm)}&entity_type=${entity_type}&limitForView=10`, {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            })
            .then((response) => {
                const results = response.data || [];

                if (results.length === 0) {
                    if (isAddNew) {
                        const customEntry = {
                            id: '',
                            special_type: 'add-new',
                            name: debouncedSearchTerm
                        };

                        const notFoundEntry = {
                            special_type: 'not-found',
                            name: <p className='description'>Ничего не найдено</p>,
                        };

                        setCases([notFoundEntry, customEntry]);
                    } else {
                        setCases([{
                            special_type: 'not-found',
                            name: <p className='description'>Ничего не найдено</p>,
                        }]);
                    }
                } else {
                    if (isAddNew) {
                        const customEntry = {
                            id: '',
                            special_type: 'add-new',
                            name: debouncedSearchTerm
                        };

                        setCases([...results, customEntry]);
                    } else {
                        setCases(results);
                    }
                }
            })
            .catch((error) => {
                console.error(error);
                openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
            })
            .finally(() => {
                setLoading(false);
            });
        } else {
            setCases([]);
            setLoading(false);
        }
    }, [debouncedSearchTerm, isAllowSearching]);

    return (
        <div ref={wrapperRef}>
            <div className='rowInputWrapper'>
                <div className='inputWithLoading'>
                    <input
                        type='text'
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setIsAllowSearching(true);
                            setFormInfo((prev) => ({
                                ...prev,
                                debtor_id: '',
                                debtor_name: '',
                            }));
                            if (searchTerm !== '') {
                                setErrorsForm((prev) => ({
                                    ...prev,
                                    debtor: '',
                                }));
                            }
                        }}
                        onFocus={() => setIsAllowSearching(true)}
                        onKeyDown={(e) => {
                            if (cases.length === 0) return;

                            if (e.key === 'ArrowDown') {
                                e.preventDefault();
                                setActiveIndex((prev) => (prev + 1) % cases.length);
                            } else if (e.key === 'ArrowUp') {
                                e.preventDefault();
                                setActiveIndex((prev) => (prev - 1 + cases.length) % cases.length);
                            } else if (
                                e.key === 'Enter' &&
                                activeIndex !== -1 &&
                                cases[activeIndex]?.special_type !== 'not-found'
                            ) {
                                const selected = cases[activeIndex];
                                setFormInfo((prev) => ({
                                ...prev,
                                debtor_id: selected.id,
                                debtor_name: selected.name,
                                }));
                                setErrorsForm((prev) => ({
                                ...prev,
                                court: '',
                                }));
                                setSearchTerm(selected.name);
                                setIsAllowSearching(false);

                                e.target.blur();
                            }
                        }}
                        className={errorsForm?.debtor ? 'inputError' : ''}
                        placeholder={entity_type == 'Физическое лицо' ? 'ФИО' : entity_type == 'Юридическое лицо' ? 'Наименование' : 'Наименование или ФИО'}
                        maxLength={150}
                        required
                    />
                    {loading && <div className='loadingInline'><Loading type="inline" /></div>}
                </div>
            {(formInfo?.debtor_name == '' || formInfo?.debtor_name==null) ? (
                searchTerm !== '' &&
                <div className='iconStatusInputWrapper red' title='Должник не выбран'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red" viewBox="0 0 24 24" >
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"/>
                    </svg>
                </div>
            ) : (
                <div className='iconStatusInputWrapper green' title='Должник выбран'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill='green' viewBox="0 0 256 256">
                        <path d="M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z"></path>
                    </svg>
                </div>
            )}
            </div>
            {errorsForm?.debtor && <div className='errorUnderInput'>{errorsForm.debtor}</div>}

            {cases.length > 0 && (
            <div className={miniTable.tableAbsoluteWrapper}>
                <div className={miniTable.table} style={{ position: 'absolute', width: '100%', boxSizing: 'border-box' }}>
                    {cases.map((caseItem, index) => (
                        <div
                            className={`${miniTable.line} ${miniTable.lineWithHover} ${index === activeIndex ? `${miniTable.highlighted}` : ''}`}
                            key={caseItem.id || caseItem.name}
                            style={{ gridTemplateColumns: '50fr 49fr 1fr', cursor: 'pointer' }}
                            onClick={() => {
                                if (cases[index]?.special_type !== 'not-found') {
                                    setErrorsForm((prev) => ({
                                        ...prev,
                                        debtor: '',
                                    }));
                                    setFormInfo((prev) => ({
                                        ...prev,
                                        debtor_id: caseItem.id,
                                        debtor_name: caseItem.name,
                                    }));
                                    setIsAllowSearching(false);
                                    setSearchTerm(caseItem.name);
                                }
                            }}
                        >
                            <div>
                                {caseItem.special_type=='add-new' && <p className='description'>Не нашли в списке нужного должника? Добавьте нового в систему</p>}
                                <p>{caseItem.name}</p>
                            </div>
                            {caseItem.special_type == '' && <div>{formatNull(caseItem.postal_address)}</div>}
                            <div className={miniTable.actions}>
                                {caseItem.special_type!=='not-found' && (
                                    <IconContainer
                                        Icon={caseItem.special_type == 'add-new' ? PlusIcon : CheckIcon}
                                        label={caseItem.special_type == 'add-new' ? 'Добавить нового и прикрепить к карточке' : 'Прикрепить к карточке'}
                                        onClick={() => {
                                            setErrorsForm((prev) => ({
                                                ...prev,
                                                debtor: '',
                                            }));
                                            setFormInfo((prev) => ({
                                                ...prev,
                                                debtor_id: caseItem.id,
                                                debtor_name: caseItem.name,
                                            }));
                                            setIsAllowSearching(false);
                                            setSearchTerm(caseItem.name);
                                        }}
                                        size='16'
                                        color='green'
                                    />
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            )}
            {(formInfo.debtor_name && !formInfo.debtor_id) &&
            <div style={{marginTop: '5px'}}>
                <WarningPanel text={
                <>
                    Вы хотите добавить нового должника, так как не нашли его в списке.<br/>
                    Пожалуйста, убедитесь, что нужный вариант действительно отсутствует, чтобы не создавать дубликаты.<br/>
                    Попробуйте изменить поисковый запрос, например, начните вводить фамилию или наименование
                </>} 
                />
            </div>}
        </div>
    );
};
